import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import AuthOptions from './authOptions';
import SetupAuthApp from './setupAuthApp';
import RecoveryCodes from './recoveryCodes';
import ResetRecoveryCodes from './resetRecoveryCodes';
import DisableTwoFactor from './disableTwoFactor';
import ResetAuthKey from './resetAuthKey';

@inject('twoFAStore') @observer
export default class twoFactorAuthentication extends Component {

    render() {
        const { currentStep, twoFactorSteps } = this.props.twoFAStore;
        switch (currentStep) {
            case twoFactorSteps.authoptions:
                return (
                    <AuthOptions />
                )
            case twoFactorSteps.setupauthapp:
                return (
                    <SetupAuthApp isMyProfileMode={true} />
                    )
            case twoFactorSteps.recoverycodes:
                return (
                    <RecoveryCodes />
                )
            case twoFactorSteps.resetcodes:
                return (
                    <ResetRecoveryCodes />
                    )
            case twoFactorSteps.disable2fa:
                return (
                    <DisableTwoFactor />
                )
            case twoFactorSteps.resetauthkey:
                return (
                    <ResetAuthKey/>
                )
            default:
                return (
                    <AuthOptions />
                )
        }
    }
}